import 'slick-carousel';
import 'fancybox-core';
import 'fancybox-media';

const $mediaCarousel = $('.js-media-carousel-items');
const $navCarousel = $('.js-media-carousel-nav');

if ($mediaCarousel.find('.media-item').length) {
  $mediaCarousel.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.js-media-carousel-nav',
  });
  $mediaCarousel.find('.media-item.video-item .fancybox').fancybox({
    openEffect: 'none',
    closeEffect: 'none',
    type: 'iframe',
    closeBtn: true,
    width: 1920,
    height: 1080,
    aspectRatio: true,
    padding: 0,
  });
  $mediaCarousel.find('.media-item.image-item .fancybox').fancybox({});
}

if ($navCarousel.find('.media-nav').length) {
  $navCarousel.slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.js-media-carousel-items',
    dots: true,
    arrows: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  });
}
